<template>
  <v-container fluid>
    <v-row align="center" justify="space-around">
      <v-col lg="6" sm="12" md="5" cols="12">
        <v-col lg="10" sm="12" md="12" cols="12" style="padding: 0; text-align: initial;">
          <p style="text-align: left;">{{ $t("nameReport") }}</p>
          <v-text-field
            solo
            :label="$t('nameReport')"
            append-icon="mdi-file"
            :color="colorTheme"
            v-model="NameOfReport"
          ></v-text-field>
        </v-col>
        <v-col lg="12" sm="12" md="12" cols="12" style="padding: 0; text-align: initial;">
          <p style="text-align: start;">{{ $t("period") }}</p>
        </v-col>

        <v-row style="padding:10px !important;">
          <v-col lg="5" sm="6" md="6" cols="12" style="padding: 0; display: table-cell;">
            <v-menu offset-x :close-on-content-click="false" :min-width="290" style="width:100%;">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateReport"
                  style="width: 100%;padding-right: 5px;"
                  solo
                  readonly
                  :label="$t('startDate')"
                  append-icon="mdi-arrow-right"
                  :color="colorTheme"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                style="min-width: 290px; display: grid;"
                v-model="startDate"
                no-title
                :max="maxDate"
                :color="colorTheme"
                :locale="this.$i18n.locale"
              ></v-date-picker>
              <v-card style="max-width: 290px;">
                <div style="display: table-cell; padding-right: 10px; padding-left: 20px">
                  <v-select
                    :color="colorTheme"
                    :item-color="colorTheme"
                    style="width: 70px;"
                    :items="Hours"
                    v-model="startTime.selectHour"
                  ></v-select>
                </div>
                <div style="display: table-cell; padding-right: 10px;">
                  <label>:</label>
                </div>
                <div style="display: table-cell; padding-right: 10px;">
                  <v-select
                    :color="colorTheme"
                    :item-color="colorTheme"
                    style="width: 70px;"
                    v-model="startTime.selectMin"
                    :items="Minutes"
                  ></v-select>
                </div>
                <div style="display: table-cell;">
                  <v-select
                    :color="colorTheme"
                    :item-color="colorTheme"
                    style="width: 57px;"
                    v-model="startTime.selectMode"
                    :items="ampm"
                  ></v-select>
                </div>
              </v-card>
            </v-menu>
          </v-col>
          <v-col lg="5" sm="6" md="6" cols="12" style="padding: 0; display: table-cell;">
            <v-menu :close-on-content-click="false" :min-width="290" style="width:100%;">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateReport"
                  style="width: 100%;"
                  solo
                  readonly
                  :label="$t('endDate')"
                  append-icon="mdi-calendar"
                  :color="colorTheme"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                style="min-width: 290px; display: grid;"
                v-model="endDate"
                no-title
                :max="maxDate"
                :min="startDate"
                :color="colorTheme"
                :locale="this.$i18n.locale"
              ></v-date-picker>
              <v-card style="max-width: 290px; padding-right: 15px !important;">
                <div style="display: table-cell; padding-right: 10px; padding-left: 20px">
                  <v-select
                    :color="colorTheme"
                    style="width: 70px;"
                    :items="Hours"
                    v-model="endTime.selectHour"
                  ></v-select>
                </div>
                <div style="display: table-cell; padding-right: 10px;">
                  <label>:</label>
                </div>
                <div style="display: table-cell; padding-right: 10px;">
                  <v-select
                    :color="colorTheme"
                    v-model="endTime.selectMin"
                    style="width: 70px;"
                    :items="Minutes"
                  ></v-select>
                </div>
                <div style="display: table-cell;">
                  <v-select
                    :color="colorTheme"
                    style="width: 57px;"
                    v-model="endTime.selectMode"
                    :items="ampm"
                  ></v-select>
                </div>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
        <v-row style="padding:10px !important;">
          <v-col
            lg="5"
            sm="6"
            md="6"
            cols="12"
            style="text-align: initial; padding: 0; display: table-cell;"
          >
            <p style="text-align: left;">{{ $t("selectV") }}</p>
            <v-text-field
              style="width: 100%;padding-right: 5px;"
              v-model="NoVehicles"
              solo
              readonly
              :label="$t('selectV')"
              append-icon="mdi-car"
              :color="colorTheme"
            ></v-text-field>
          </v-col>
          <v-col
            lg="5"
            sm="6"
            md="6"
            cols="12"
            style="text-align: initial; padding: 0; display: table-cell;"
          >
            <p style="text-align: left;">{{ $t("type2") }}</p>
            <v-text-field
              style="width: 100%;"
              solo
              v-model="TypeOfReport"
              readonly
              :label="$t('type2')"
              append-icon="mdi-content-copy"
              :color="colorTheme"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-col
          lg="10"
          md="12"
          sm="12"
          cols="12"
          style="text-align: initial; padding: 0;">
          <p style="text-align: left;">{{ $t("sendEmail") }}</p>
          <v-combobox
            v-model="Emails"
            :label="$t('sendEmail')"
            small-chips
            cleareable
            solo
            multiple
            @keyup.space="alert()"
            append-icon
            prepend-inner-icon="mdi-email-outline"
            :deletable-chips="true"
            :color="colorTheme"
            :rules="emailsReport"
            ref="form"
          ></v-combobox>
        </v-col>
      </v-col>
      <v-col lg="6" sm="12" md="7" cols="12">
        <v-card class="mb-5" height="100%" style="margin: 0 !important;">
          <v-card class="mb-5" style="margin: 0 !important; min-height: 45px; max-height: 55px;">
            <P style=" margin: 0;padding: 10px;">{{ $t("selCols") }}</P>
          </v-card>
          <v-container grid-list-xl fluid style=" padding: 6px;">
            <v-layout row wrap>
              <v-col lg="6" md="6" sm="12" cols="12" style="padding: 10 !important;">
                <v-list v-for="item in Columns" :key="item.value" style="padding: 0 !important;">
                  <v-list-item style="height: 40px;" @click.prevent>
                    <v-list-tile-action v-if="item.value == 18" @click="checkAll()">
                      <v-checkbox id="checkbox" v-model="all" :disabled="true" :color="colorTheme"></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-action v-else>
                      <v-checkbox v-model="item.active" :color="colorTheme"></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content v-if="item.value == 18" @click="checkAll()">
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-content v-else @click="item.active = !item.active">
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col lg="6" md="6" sm="12" cols="12" style="padding: 10 !important;">
                <v-list v-for="item in Columns2" :key="item.value" style="padding: 0 !important;">
                  <v-list-item style="height: 40px;" @click.prevent>
                    <v-list-tile-action>
                      <v-checkbox v-model="item.active" :color="colorTheme"></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content @click="item.active = !item.active">
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-layout>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "reportDetails",
  data: () => ({
    currentDate: new Date(),
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    startTime: {},
    endTime: {},
    emailsReport: [
      v => {
        if (!v || v.length < 1) return true;
        else if (v.length > 0) {
          var validemail = "";
          v.forEach(element => {
            if (
              !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                element
              )
            ) {
              validemail = i18n.t("invalidEmail");
              return;
            } else {
              validemail = true;
            }
          });
          return validemail;
        } else return true;
      }
    ]
  }),
  computed: {
    ...mapState([
      "Columns",
      "Columns2",
      "maxDate",
      "TypeOfReport",
      "ampm",
      "Minutes",
      "Hours",
      "all",
      "colorTheme"
    ]),

    NoVehicles: {
      get: function() {
        return this.$store.state.vehicles.length;
      },
      set: function() {}
    },

    NameOfReport: {
      get: function() {
        return this.$store.state.NameOfReport;
      },
      set: function(value) {
        this.$store.commit("setDataReport", value);
      }
    },

    startDateReport: {
      get: function() {
        return this.$store.state.startDateReport;
      },
      set: function(value) {}
    },

    endDateReport: {
      get: function() {
        return this.$store.state.endDateReport;
      },
      set: function(value) {}
    },

    endDate: {
      get: function() {
        return this.$store.state.endDate;
      },
      set: function(value) {
        this.$store.commit("setDatesReport", ["end", value]);
      }
    },

    startDate: {
      get: function() {
        return this.$store.state.startDate;
      },
      set: function(value) {
        this.$store.commit("setDatesReport", ["start", value]);
      }
    },

    Emails: {
      get: function() {
        return this.$store.state.Emails;
      },
      set: function(value) {
        this.$store.commit("addEmails", value);
      }
    }
  },
  created() {
    this.startTime = this.$store.state.startTime;
    this.endTime = this.$store.state.endTime;
  },
  watch: {
    startTime: {
      deep: true,

      handler() {
        this.$store.commit("selectedTime", ["start", this.startTime]);
      }
    },
    endTime: {
      deep: true,
      handler() {
        this.$store.commit("selectedTime", ["end", this.endTime]);
      }
    },
    Columns: {
      deep: true,
      handler() {
        this.$store.commit("addColumns");
      }
    },
    Columns2: {
      deep: true,
      handler() {
        this.$store.commit("addColumns");
      }
    }
  },
  methods: {
    checkAll() {
      this.$store.commit("checkAllColumns");
    }
  }
};
</script>

<style scoped>
.centered-input input {
  text-align: center !important;
}
</style>
